<div class="accsection">
    <div class="as-head" [class.active]="active" [innerHTML]="head" (click)="toggle();"></div>
    <div class="as-content" [innerHTML]="content" #contentDiv></div>
</div>
